import {
  PartnerIndependentCardManagement,
  PartnerCardProviderSettingsState,
  PartnerCardProviderSettingsRequest
} from "@/admin/types";
import * as CardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { FetchState } from "@/shared/types";
import { defineStore } from "pinia";
import Vue from "vue";
import { useNotifierStore } from "@/shared/store/notifier";
import _ from "lodash";

export const initialState: PartnerCardProviderSettingsState = {
  partnerId: null,
  fetchStateHasIndependentCardManagement: FetchState.Uninitialized,
  hasIndependentCardManagement: false
};

export const usePartnerCardProviderSettingsStore = defineStore("partnerCardProviderSettings", {
  state: () => (_.cloneDeep(initialState)),
  getters: {
    isLoading: state => state.fetchStateHasIndependentCardManagement === FetchState.Loading,
    isLoaded: state => state.fetchStateHasIndependentCardManagement === FetchState.Loaded,
  },

  actions: {
    setIndependentCardManagementResult (response: PartnerIndependentCardManagement) {
      this.fetchStateHasIndependentCardManagement = FetchState.Loaded;
      this.hasIndependentCardManagement = response.hasIndependentCardManagement;
    },


    loadPartnerCardProviderSettings (partnerId: number): Promise<any> {
      if (this.partnerId === partnerId &&
        this.fetchStateHasIndependentCardManagement !== FetchState.Uninitialized) {

        return Promise.resolve();
      }

      this.partnerId = partnerId;
      this.fetchStateHasIndependentCardManagement = FetchState.Uninitialized;
      return this.loadPartnerIndependentCardMangement(partnerId);
    },

    loadPartnerIndependentCardMangement (partnerId: number): Promise<any> {
      if (this.fetchStateHasIndependentCardManagement !== FetchState.Uninitialized) {
        return Promise.resolve();
      }

      this.fetchStateHasIndependentCardManagement = FetchState.Loading;
      return CardService.getPartnerIndependentCardMangement(partnerId)
        .then(response => {
          this.setIndependentCardManagementResult(response.data);
        });
    },

    setPartnerCardProviderSettings (settings: PartnerCardProviderSettingsRequest): Promise<any> {
      if (! this.isLoaded || this.partnerId !== settings.partnerId) {
        return Promise.reject();
      }

      return CardService.setPartnerIndependentCardMangement(
        settings.partnerId,
        { hasIndependentCardManagement: settings.hasIndependentCardManagement }
      ).then(() => {
        this.setIndependentCardManagementResult(settings);
        return Promise.resolve();
      }).catch(err => storeHelper.handleError({ error: err, rethrow: true }));
    }
  }
});
